module.exports = __webpack_public_path__ + "static/media/Rovr.40a7abdf.md";